<template>
<w-sliding-popup ref="slidingPopup" type="setting" title="수집 서버 그룹 추가" width="500px" @open="open" @close="close">
  <div slot="content">
    <el-form :model="agentGroupData" label-position="top" :rules="rules" ref="agentGroupForm">
      <el-form-item label="그룹번호" prop="agentManagerGroupId">
        <el-input-number v-model="agentGroupData.agentManagerGroupId" controls-position="right" :min="1" :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="그룹명" prop="agentManagerGroupName">
        <el-input v-model="agentGroupData.agentManagerGroupName" placeholder="입력해 주세요."></el-input>
      </el-form-item>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="saveButton">저장</el-button>
    <el-button size="large" @click="cancelButton">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import AgentSettingsAPI from '@/api/settings/common/agent-settings';

export default {
  name: 'WAddAgentGroupPopup',
  data() {
    const validateAgentManagerGroupId = (rule, value, callback) => {
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        AgentSettingsAPI.checkAgentManagerGroupIdValidation({
          agentManagerGroupId: value,
        }).then((response) => {
          if (response.data.data) {
            callback();
          } else {
            callback(new Error('이미 사용 중인 그룹 번호입니다.'));
          }
        });
      }
    };
    return {
      agentGroupData: {
        agentManagerGroupId: null,
        agentManagerGroupName: null,
      },
      rules: {
        agentManagerGroupId: {
          required: true,
          validator: validateAgentManagerGroupId,
          trigger: 'blur',
        },
        agentManagerGroupName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    open() {},
    close() {
      this.$refs.agentGroupForm.resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    saveButton() {
      this.$refs.agentGroupForm.validate().then((response) => {
        if (response) {
          const action = msgUtil.action.ADD;
          const target = '수집 서버 그룹';
          AgentSettingsAPI.insertAgentGroup(this.agentGroupData)
            .then((res) => {
              if (res.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.closePopup();
                this.$emit('reload-data');
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
        }
      });
    },
    cancelButton() {
      this.closePopup();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/AgentSettings/popup/AddAgentGroupPopup.vue